import { render, staticRenderFns } from "./client-roster.vue?vue&type=template&id=e2e885dc&scoped=true"
import script from "./client-roster.vue?vue&type=script&lang=js"
export * from "./client-roster.vue?vue&type=script&lang=js"
import style0 from "./client-roster.vue?vue&type=style&index=0&id=e2e885dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e885dc",
  null
  
)

export default component.exports